import { easings } from '@react-spring/web';

export const config = (() => ({
  config: {
    duration: 700,
    easing: easings.easeInOutQuad,
  },
  reset: true,
  immediate: false,
}))();
